import * as ActionTypes from '../ActionTypes';

const initState = {
    authResponse: "",
    loginNotifier:false,
    credentials:"",
    userDetail:""
  };
  
  const AuthReducer = (state = initState, action) => {
    switch (action.type) {
      case ActionTypes.RESTART_AUTH_RESPONSE:
        
        return {
          ...state,
          authResponse: "",
        };
      case ActionTypes.LOADING:
        return {
          ...state,
          authResponse: "loading...",
        };
  
      case ActionTypes.SIGNUP_SUCCESS:
        return {
          ...state,
          loginNotifier:false,
          authResponse: action.res,
        };
  
      case ActionTypes.SIGNUP_ERROR:
        return {
          ...state,
          loginNotifier:false,
          authResponse: action.res,
        };
  
        case ActionTypes.LOGIN_SUCCESS:
          return {
            ...state,
            
            loginNotifier:true,
            credentials: action.res,
            authResponse: "redirecting to dashboard...",
          };
      case ActionTypes.LOAD_USER_SUCCESS:
        return {
          ...state,

          loginNotifier: true,
          userDetail: action.res,
        };
      case ActionTypes.LOAD_USER_ERROR:
        return {
          ...state,

          loginNotifier: true,
          userDetail: action.res,
        };
        
        case ActionTypes.LOGIN_ERROR:
          return {
            ...state,
            loginNotifier:false,
            authResponse: action.res,
          };  
  
  
          case ActionTypes.LOGOUT_SUCCESS:
            return {
              ...state,
              loginNotifier:false,
              authResponse: action.res,
            };
      
          case ActionTypes.LOGOUT_ERROR:
            return {
              ...state,
              authResponse: action.res,
            };    
  
      case ActionTypes.CODE_ERROR:
        return {
          ...state,
          authResponse:
            "There seems to be a problem, please refresh your browser",
        };
  
      default:
        if (sessionStorage.getItem('user-token')!=null){
          return {
            ...state,
            loginNotifier:true,
            credentials:state.credentials,
          }; 
        } else{
          return {
          ...state,
          
          loginNotifier:false
        }; 
      }
    }
  };
  
  export default AuthReducer;
  
